export default __webpack_public_path__ + "static/media/17.c4ab5180.png";